import { Component, Input, Output, EventEmitter } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { PaymentCancellationComponent } from "app/core/payment-cancellation/payment-cancellation.component";
import { TaxAdvisorLicenceComponent } from "app/core/tax-advisor-licence/tax-advisor-licence.component";
import { PackageOptions } from "app/statements/package-options";
import { Statement } from "app/statements/statement";
import { TermsFilesService } from "app/core/services/terms-files.service";
import { PrivacyPolicyEtxComponent } from "app/core/privacy-policy-etx/privacy-policy-etx.component";
import { PaymentCancellationEtxComponent } from "app/core/payment-cancellation-etx/payment-cancellation-etx.component";
import { GeneralTaxAdvisorRulesComponent } from "app/core/general-tax-advisor-rules/general-tax-advisor-rules.component";
import { PrivacyPolicyComponent } from "app/standalone-pages/privacy-policy/privacy-policy.component";
import { TermsAndConditionsComponent } from "app/standalone-pages/terms-and-conditions/terms-and-conditions.component";

@Component({
  selector: "app-payment-regulations",
  templateUrl: "./payment-regulations.component.html",
  styleUrls: ["./payment-regulations.component.scss"],
  standalone: false
})
export class PaymentRegulationsComponent {
  @Input() statement: Statement;
  @Input() termRegulationsIsChecked: boolean;
  @Input() termRealDataIsChecked: boolean;
  @Output() clickTermRegulations = new EventEmitter();
  @Output() clickTermRealData = new EventEmitter();
  public packageOption = PackageOptions;

  constructor(
    private dialog: MatDialog,
    private termsFilesService: TermsFilesService
  ) {}

  openTermsAndConditions() {
    this.dialog.open(TermsAndConditionsComponent, { autoFocus: false });
  }

  openPaymentCancellationDialog() {
    this.dialog.open(PaymentCancellationComponent);
  }

  openPaymentCancellationEtxDialog() {
    this.dialog.open(PaymentCancellationEtxComponent);
  }

  openGeneralTaxAdvisorRulesDialog() {
    this.dialog.open(GeneralTaxAdvisorRulesComponent);
  }

  openPrivacyPolicy() {
    this.dialog.open(PrivacyPolicyComponent, { autoFocus: false });
  }

  public openTaxAdvisorLicence() {
    this.dialog.open(TaxAdvisorLicenceComponent);
  }

  public openPrivacyPolicyEtx() {
    this.dialog.open(PrivacyPolicyEtxComponent);
  }

  public showRegulationCheckBox(): boolean {
    return !!this.statement?.isPremiumPackage;
  }
}
